<template>
  <component :is="tag" :class="tag === 'p' ? 'list-owner official-list' : null">Curated list</component>
</template>

<script setup>
defineProps({ tag: { type: String, default: 'p' } })
</script>
